// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{overflow:hidden;width:100vw;height:100vh;font-size:14px}", ""]);
// Exports
module.exports = exports;
